<template>
  <v-app id="inspire">
    <v-main class="bg-secondary-light">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="12" align="center">
            <template>
              <a href="/">
                <v-img
                  :src="'/storage/' + main.logo"
                  :lazy-src="'/storage/' + main.logo"
                  class="mb-0"
                  :max-width="main.logoWidth"
                  :max-height="main.logoHight"
                />
              </a>
            </template>
            <slot></slot>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  computed: {
    main() {
      return this.$store.getters["configs/overall"];
    },
  },
};
</script>
